// extracted by css-extract-rspack-plugin
export default {"cls1":"NewCitationPing-cls1_XAr","cls2":"NewCitationPing-cls2_juN NewCitationPing-cls1_XAr"};